.headerContainer {
  position: relative;
}

.popover {
  box-shadow:
    rgb(0 0 0 / 20%) 0px 3px 1px -2px,
    rgb(0 0 0 / 14%) 0px 2px 2px 0px,
    rgb(0 0 0 / 12%) 0px 1px 5px 0px;
  min-width: 260px;
  position: fixed;
  pointer-events: none;
  opacity: 0;
  right: 0;
  padding: 15px;
  text-align: left;
  border-radius: 4px;
  background-color: rgb(255, 255, 255);
}

.popover > div > div > span {
  white-space: normal;
}

.headerContainer:hover .popover {
  opacity: 1;
  pointer-events: auto;
}
